// extracted by mini-css-extract-plugin
export default {"title":"Dashboard_title__9In9c","welcome-text":"Dashboard_welcome-text__dvRfn","info-text":"Dashboard_info-text__fW490"};